import { InputMask, InputMaskProps, InputMaskChangeEvent } from 'primereact/inputmask';
import { Column } from '../container/Container';
import { TextBodyExtraExtraSmall } from '../text/Texts';
import { cn } from '../ui/cn';
import { useState } from 'react';
import { FormElementProps } from './InputController';
import { inputStyle, labelStyle } from './styles';

interface MaskInputProps extends Omit<InputMaskProps, 'value' | 'onChange' | 'onBlur'>, FormElementProps {
	label?: string;
	disableAutoSelect?: boolean;
	icon?: React.ReactNode;
}

const MaskInput = ({
	id,
	value,
	onChange,
	onBlur,
	error,

	label,
	variant = 'filled',
	disableAutoSelect,
	icon,
	...inputMaskProps
}: MaskInputProps) => {
	const [isFocus, setIsFocus] = useState(false);

	const hasValue = value !== null && value !== undefined && value !== '';

	return (
		<Column className={cn('w-full relative', inputMaskProps.disabled && 'opacity-50')}>
			<InputMask
				unstyled
				{...inputMaskProps}
				id={id}
				value={value}
				onChange={(e: InputMaskChangeEvent) => onChange?.(e.value)}
				onClick={(e) => e.stopPropagation()}
				onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
					setIsFocus(true);

					if (disableAutoSelect)
						setTimeout(() => {
							if (e.target) {
								const length = e.target.value?.length || 0;
								e.target.setSelectionRange(length, length);
							}
						}, 100);
				}}
				onBlur={() => {
					setIsFocus(false);
					onBlur?.();
				}}
				variant={undefined}
				pt={{ root: { className: cn(inputStyle({ variant, isFocus, error: !!error }), 'font-robotomono') } }}
			/>

			{/* Icon */}
			{icon && (<div children={icon} className="absolute right-3 top-4" />)}

			{/* Label */}
			{label && (
				<label
					htmlFor={id}
					children={label}
					className={labelStyle({ variant, isFocus, hasValue, error: !!error })}
				/>
			)}

			{/* Error */}
			{(error && error.message) && (
				<TextBodyExtraExtraSmall children={error.message} className="pl-4 pt-1 text-error" />
			)}
		</Column>
	);
};

export default MaskInput;
